export default "__VITE_ASSET__Cb_esCRZ__"